import Typography from '~/components/Typography.tsx';
import ValuePair from '~/components/ValuePair.tsx';
import Container from '~/components/Container.tsx';
import Area from '~/components/Area.tsx';
import useDelivery from '~/pages/shop/hooks/useDelivery.ts';
import useKupStore from '~kup/store';
import { useTranslation } from 'react-i18next';
import useCouponHelper from '~/hooks/useCouponHelper.ts';
import IssuableCouponsButton from '~/components/IssuableCouponsButton.tsx';

export default function KupShoppingBenefits() {
  const { currency, basket } = useKupStore((state) => ({
    currency: state.currency,
    basket: state.basket,
  }));
  const { i18n } = useTranslation();
  const checkedItems = basket.items;
  const checkedAvailableAmount = checkedItems
    .map((i) => i.availableAmount)
    .reduce((a, b) => a + b, 0);
  const delivery = useDelivery(checkedAvailableAmount);
  const deliveryFee = checkedAvailableAmount > 0 ? delivery.fee : 0;
  const { issuableCoupons, bestUsableCoupon, handleIssueCoupons } = useCouponHelper(
    checkedItems.map((item) => item.id ?? '').filter((s) => !!s)
  );

  return (
    <Area
      title={
        <Typography color={'text.primary'} variant={'BaseM_B'}>
          {i18n.t('shop-product-benefits-in-your-cart')}
        </Typography>
      }
      headerContainerProps={{
        px: '20px',
        pb: '16px',
      }}
      containerProps={{
        stackProps: {
          column: true,
          gap: '20px',
        },
      }}
    >
      {deliveryFee === 0 && (
        <ValuePair
          py={'0px'}
          label={<Typography whiteSpace={'nowrap'}>{i18n.t('shop-basket-deliveryFee')}</Typography>}
          value={i18n.t('shop-basket-free-delivery')}
        />
      )}
      {bestUsableCoupon && (
        <ValuePair
          py={'0px'}
          label={
            <Typography whiteSpace={'nowrap'}>
              {i18n.t('common-coupon-discount')}({bestUsableCoupon.coupon?.name ?? ''})
            </Typography>
          }
          value={`${currency} ${bestUsableCoupon.applicableDiscountAmount?.toLocaleString() ?? ''}`}
        />
      )}
      {issuableCoupons && (issuableCoupons?.length ?? 0) > 0 && (
        <Container px={'20px'}>
          <IssuableCouponsButton issuableCoupons={issuableCoupons} onClick={handleIssueCoupons} />
        </Container>
      )}
    </Area>
  );
}
